import { useI18n } from "vue-i18n";

interface TranslationHelper {
    changeCode(code: number): string;
}

export function returnCode(): TranslationHelper {
    const { t } = useI18n();

    return {
        changeCode: (code: number): string => t(`return_code.${code.toString()}`) as string, // 반환 유형을 string으로 지정
    };
}

// returnCodeMap.ts
const returnCodeMap: Record<number, string> = {
    0: "성공했습니다.",
    1: "내부 오류가 발생했습니다.",
    2: "실행 중 오류가 발생했습니다.",
    3: "접근이 거부되었습니다.",
    4: "권한이 없습니다.",
    5: "필수 값이 누락되었습니다.",
    6: "사용자를 찾을 수 없습니다.",
    7: "사용할 수 없는 사용자입니다.",
    8: "승인 전 상태의 사용자입니다.",
    9: "승인 요청 중인 사용자입니다.",
    10: "승인이 거부된 사용자입니다.",
    11: "토큰이 만료되었습니다.",
    12: "유효하지 않은 토큰입니다.",
    13: "이미 사용 중인 사용자입니다.",
    14: "사용자가 권한이 없습니다.",
    15: "잘못된 요청 값입니다.",
    16: "차단된 사용자입니다.",
    17: "토큰 저장에 실패했습니다.",
    18: "회원가입이 필요합니다.",
    19: "접근 권한이 없습니다.",
    21: "이미 사용 중인 아이디/이메일입니다.",
    22: "비밀번호가 올바르지 않습니다.",
    23: "아이디는 5~10자의 영문/숫자만 가능합니다.",
    24: "이름은 3~10자의 문자만 가능합니다.",
    25: "비밀번호는 8~16자의 영문, 숫자, 특수문자를 조합해야 합니다.",
    26: "휴대폰 번호 형식이 올바르지 않습니다.",
    27: "잘못된 접근입니다.",
    28: "이미 사용 중인 경로입니다.",
    29: "데이터를 찾을 수 없습니다.",
    30: "유효하지 않은 데이터입니다.",
    31: "데이터 저장에 실패했습니다.",
    32: "데이터 변경에 실패했습니다.",
    33: "이메일 형식이 올바르지 않습니다.",
    34: "파일 업로드 개수 제한을 초과했습니다.",
    35: "파일 업로드는 이미지만 가능합니다.",
    37: "아직 준비되지 않았거나, 활성화되기 전입니다.",
    40: "설정값은 6시간 ~ 720시간 사이여야 합니다.",
    51: "검색 API가 실행되지 않았습니다.",
    52: "이미 삭제된 데이터입니다.",
    53: "데이터가 저장되지 않았습니다.",
    54: "이미 사용 중인 데이터입니다.",
    55: "데이터가 준비되지 않았습니다.",
    56: "신청 기한이 아닙니다.",
    57: "삭제가 불가능합니다.",
    997: "SNS 인증에 실패했습니다.",
    998: "SNS 로그인에 실패했습니다.",
    999: "삭제된 사용자입니다.",
};

export const getMessageByCode = (code: number): string => {
    return returnCodeMap[code] ?? "알 수 없는 오류가 발생했습니다.";
};
